import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';

export type QuickStartLinkSignature = {
  Args: {
    route: string;
    icon: string;
    title: string;
    description: string;
  };
  Element: HTMLDivElement;
};

export const QuickStartLink = <template>
  <div class="card border-0 shadow-sm rounded-4" ...attributes>
    <div class="card-body p-4">
      <iconify-icon
        inline
        icon={{@icon}}
        class="fs-3 text-primary mb-3"
        aria-hidden="true"
      />
      <h3 class="h6 fw-bold mb-2"><LinkTo
          @route={{@route}}
          class="stretched-link"
        >{{@title}}
          <iconify-icon
            inline
            icon="ph:arrow-right-bold"
            aria-hidden="true"
          /></LinkTo></h3>
      <p class="card-text mb-0 text-body-secondary small">{{@description}}</p>
    </div>
  </div>
</template> satisfies TOC<QuickStartLinkSignature>;
